"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("@superlogica/foundation/utils");

var _styledComponents = require("styled-components");

var _erp = _interopRequireDefault(require("./erp"));

var _gruvi = _interopRequireDefault(require("./gruvi"));

var _superlogica = _interopRequireDefault(require("./superlogica"));

var _excluded = ["fill", "name", "theme"];
var iconLibrary = {
  erp: _erp.default,
  gruvi: _gruvi.default,
  superlogica: _superlogica.default
};

var Icon = function Icon(_ref) {
  var _iconLibrary$theme$na;

  var fill = _ref.fill,
      name = _ref.name,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var iconProps = (0, _objectSpread2.default)({}, rest);

  if (fill && theme.colors[fill]) {
    iconProps.color = (0, _utils.parseColor)(theme.colors[fill]);
  }

  var Vector = (_iconLibrary$theme$na = iconLibrary[theme.name][name]) !== null && _iconLibrary$theme$na !== void 0 ? _iconLibrary$theme$na : iconLibrary.superlogica.default;
  return /*#__PURE__*/_react.default.createElement(Vector, iconProps);
};

var _default = (0, _styledComponents.withTheme)(Icon);

exports.default = _default;